import { jsx as _jsx } from "react/jsx-runtime";
import { ActivityList as _List } from './list';
import { ActivityTable as _Table } from './table';
import { useBreakpoints } from '../../hooks';
export function ActivityList(props) {
    const { breakpoints } = useBreakpoints();
    if (breakpoints.XS) {
        return _jsx(_List, Object.assign({}, props));
    }
    return _jsx(_Table, Object.assign({}, props));
}
